import { useGetContextOrError } from '@/lib/hooks/use-get-context-or-error';

import { context } from './context';

export const useMainScrollContainerId = () =>
  useGetContextOrError(context, 'Main Scroll Container');
